var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartCard',{staticClass:"stat",attrs:{"title":_vm.title,"is-loading":_vm.isLoading}},[(_vm.badge)?_c('Badge',{staticClass:"v-chart-card__badge",attrs:{"slot":"badge","color":_vm.badgeColor,"content":_vm.badge},slot:"badge"}):_vm._e(),_vm._v(" "),_c('VText',{staticClass:"analytics-number",attrs:{"component":"span"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }